export enum ShipmentTransportOrderEndpoint {
  Base = '/shipments',
  Count = '/count',
  Equipments = '/equipments',
  Tos = '/tos',
  Summary = '/summary',
  Materials = '/materials',
  Map = '/map',
  Milestones = '/milestones',
  Notifications = '/notifications',
  OuterPackages = '/outer-packages',
  PlannedInfos = '/planned-infos',
  StatusHistories = '/load-histories',
  Loads = '/loads',
  Parties = '/parties',
}
